import { useStore } from '../store/useStore';
import { t } from './index';

/**
 * Returns the `t` translator and subscribes the calling component to locale
 * changes (so it re-renders when the language switches). Use as
 * `const t = useT()` then `t('some.key')`.
 */
export function useT(): typeof t {
  // Subscribe to the locale so components re-render on language change.
  useStore((s) => s.locale);
  return t;
}
